import { useState, useEffect } from "react";
import { getArticlesByCategoryWidget } from "../api/widgets/articlesByCategory/requests";

function useStoryblokArticlesByCategoryWidget(category) {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getArticlesByCategoryWidget(category)
      .then((data) => {
        if (data) {
          setData(data);
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .then(() => setIsLoading(false));
  }, []);

  return [data, isLoading];
}

export { useStoryblokArticlesByCategoryWidget };
